(function () {
  /**
   * @deprecated Migrated to GlobalAdminPolicyList.js
   *
   * @ngdoc factory
   * @name GlobalAdminPolicyList
   * @description Model for organization policies which are set by GAC (Global Admin Console)
   */
  angular.module('binky.core.globalAdmin').factory('GlobalAdminPolicyList', factory);

  /* @ngInject */
  function factory(
    _,
    binkySrc2,
    feature,
    GlobalAdminPolicy,
    jilGlobalAdminPolicies,
    List,
    modelCache,
    promiseUtils
  ) {
    const POLICIES_CACHE_ID = 'GlobalAdminPolicyList';

    class GlobalAdminPolicyList extends List {
      /**
       * @description Policies for an org
       *
       * @param {Object} options Initialization options
       * @param {String} options.orgId The org ID for the policy
       * @param {Array} options.initPolicyList (optional) Data to store in the model.items. Format:
       *   [
       *     {defaultValue: Boolean, name: String, value: Boolean},
       *     {defaultValue: Boolean, name: String, value: Boolean},
       *     ...
       *   ]
       */
      constructor(options) {
        super({
          cacheType: POLICIES_CACHE_ID,
          itemClassRef: GlobalAdminPolicy,
          resource: jilGlobalAdminPolicies.policies,
        });

        this.$resolved = false;
        initModel(this, options);
      }

      /**
       * Get the policy value
       * @param {String} policyName case sensitive policy name
       *
       * @returns {Boolean} true if the policy doesn't exist to be permissive,
       * or the policy value is true. Return false, otherwise.
       */
      getPolicyValue(policyName) {
        const policy = _.find(this.items, ['name', policyName]);
        const value = _.get(policy, 'value');
        return _.isUndefined(value) || value;
      }

      /**
       * @deprecated Unused, not migrated to React
       *
       * @description Check if any of the polies have a different value compared to its default value
       *
       * @returns {Boolean} true if one of the policies has been changed from its default value.
       * Return false otherwise.
       */
      hasChangedPolicies() {
        return _.some(this.items, (policy) => policy.value !== policy.defaultValue);
      }

      key() {
        const params = getParams.call(this);
        return super.key(params);
      }

      refresh() {
        const params = getParams.call(this);
        return super.refresh(params);
      }

      /**
       * Get the policies data
       * @param {Object} options Initialization options
       * @param {String} options.orgId The org ID for the policy
       *
       * @returns {Policies} Policies instance
       */
      static get(options) {
        const cachedModel = modelCache.get(POLICIES_CACHE_ID, options.orgId);
        if (cachedModel) {
          return cachedModel;
        }
        const model = new GlobalAdminPolicyList(options);
        model.refresh();
        return model;
      }
    }

    // Set size to 1 to ensure that only the current org is cached
    modelCache.register(POLICIES_CACHE_ID, 1);

    class GlobalAdminPolicyList2 extends binkySrc2.services.globalAdmin.GlobalAdminPolicyList {
      static get(options) {
        return promiseUtils.toAngularPromise(
          binkySrc2.services.globalAdmin.GlobalAdminPolicyList.get(options)
        );
      }
    }

    return feature.isEnabled('temp_port_global_admin_policy')
      ? GlobalAdminPolicyList2
      : GlobalAdminPolicyList;

    ////////

    /**
     * @description Returns the query params to be passed with HTTP GET requests when refreshing
     *   this PolicyList instance.
     *
     * @returns {Object} object with keys and values representing the query param names and values
     *   param value.
     */
    function getParams() {
      return {orgId: this.orgId};
    }

    /**
     * Helper method to populate 'model' with policies data
     * @param {Policies} model The actual Policies instance to update
     * @param {Object} options Initialization options
     * @param {String} options.orgId The org ID for the policy
     * @param {Array} options.initPolicyList (optional) Data to store in the model.items. Format:
     *   [
     *     {defaultValue: Boolean, name: String, value: Boolean},
     *     {defaultValue: Boolean, name: String, value: Boolean},
     *     ...
     *   ]
     */
    function initModel(model, options) {
      const {orgId, initPolicyList} = options;
      model.orgId = orgId; // Used for cache key
      model.items = _.map(initPolicyList, (policy) => new GlobalAdminPolicy(policy));
    }
  }
})();
